export const translateFR = {
  ACADEMIC_PROGRESS: "Progrès scolaires",
  ACCEPT_SEQUENCE: "Accepter la Séquence",
  ACTIVE: "Actif",
  ADD_ANOTHER_LANGUAGE: "Ajouter une langue",
  ADD_EMAIL: "Ajouter un e-mail",
  ADD_LANGUAGE: "Ajouter une langue",
  ADD_NEW_COMPANY: "Nouvelle compagnie",
  ADD_NEW_LINGO: "Ajouter Lingo",
  ADD_NEW_STUDENT: "Nouvel étudiant",
  ADD_NEW_TICKET: "Nouveau Billet",
  ADD_NEW: "Ajouter un nouveau",
  ADD_TEACHER: "Nouveau professeur",
  ADD_TELEPHONE: "Ajouter un Téléphone",
  ADD_TO_CONTRACT: "Ajouter au contrat",
  ADDRESS_PLACEHOLDER: "Addresse",
  ADDRESS: "Addresse",
  ADVANCED: "Avancé",
  ALL_LANGUAGES: "Toutes les Langues",
  ALTERNATIVE_EMAIL: "Email alternatif",
  ANALYTICS: "Analytics",
  APP: "Application",
  ASSIGNED_TEACHER: "Enseignant Assigné",
  AVAILABLE_PART_CLASSES: "Cours Supplémentaires",
  AVARAGE_RATING: "Note moyenne",
  AVERAGE: "Moyenne",
  BACK: "Retour",
  BALANCED: "Équilibré",
  BASIC: "Basique",
  BILINGUAL: "Bilingue",
  BILLING_HISTORY: "Historique de facturation",
  BILLED_MONTHLY: "facturé mensuellement",
  BIRTH_DATE: "Date of birth",
  BTN_ADD_NEW_CONTACT: "Nouveau contact",
  BTN_ADD_NEW_PLAN: "Ajouter un forfait",
  BTN_ADD_TEL: "Ajouter un téléphone",
  BTN_ADD: "Ajouter",
  BTN_BACK: "Retour",
  BTN_BUY_PLAN: "Acheter un nouveau forfait",
  BTN_CANCEL_ALL_CLASS: "Annuler toutes les séquences de cours",
  BTN_CANCEL_ONLY_CLASS: "Annuler cette séquence de cours",
  BTN_CANCEL: "Annuler",
  BTN_CLASS_SCHEDULED: "Cours Programmé!",
  BTN_CLASS_WITHOUT_TECHER: "Cours sans professeur",
  BTN_CLEAR_SEARCH: "Effacer la recherche",
  BTN_CLOSE: "Fermer",
  BTN_CONFIRM: "Confirmer",
  BTN_CREATE_ACCOUNT: "Créer mon compte",
  BTN_DAYS_TO_REPEAT_CLASS: "Sélectionnez les jours pour répéter les cours",
  BTN_DELETE: "Supprimer",
  BTN_DEMO_CLASS_WITHOUT_TECHER: "Cours de démonstration sans professeur",
  BTN_END_TIME: "Heure de fin",
  BTN_ENGLISH: "Anglais",
  BTN_HELLO: "Bonjour",
  BTN_LOGIN: "Se connecter",
  BTN_NEW_CLASS: "Nouvelle classe",
  BTN_NO_CLASSES_FOUND: "Aucun cours trouvé",
  BTN_NO: "Non",
  BTN_NOT_CANCEL_CLASS: "Ooops! Je ne veux pas annuler mon cours",
  BTN_NUMBER_CLASSES: "Nombre de cours",
  BTN_PORTUGUESE: "Portuguais",
  BTN_PROCEED_PAYMENT: "Procéder au paiement",
  BTN_REGULAR: "Régulier",
  BTN_REPEAT_UNITIL: "Répète jusqu'à",
  BTN_REQUEST: "demande",
  BTN_REVERSE_PAYMENT: "Paiement inversé",
  BTN_REVERSED_PAYMENT: "Classe Inversée",
  BTN_SAVE: "Sauvegarder",
  BTN_SCHEDULE_ADDED: "Votre cours a été ajouté à votre planning!",
  BTN_SCHEDULE_CLASS: "Programmer le cours",
  BTN_SCHEDULE_NEW_CLASS: "Planifier un nouveau cours",
  BTN_SCHEDULE: "Calendrier",
  BTN_SEARCH: "Rechercher",
  BTN_SEND: "Envoyer",
  BTN_SPANISH: "Espagnol",
  BTN_SPECIFIC: "Spécifique",
  BTN_START_TIME: "Heure de début",
  BTN_UPCOMING_CLASS: "Cours à venir",
  BTN_VIEW_ALL: "Voir tout",
  BTN_VIEW_SCHEDULE: "Voir le Calendrier",
  BTN_VIEW: "Voir",
  BTN_YES_LOVE: "Oui j'aime ça!",
  BTN_YES: "Oui",
  BULK_ADD_NEW_STUDENT: "Ajouter un étudiant en masse",
  BULK_ADD_STUDENT: "Ajouter un étudiant en masse",
  BULK_RESULTS: "Résultats",
  BUY_MORE_CLASSES: "Acheter des cours",
  CANCEL_ALL_CLASSES_MESSAGE: "L'annulation de ce cours entraînera l'annulation de tous les cours énumérés ci-dessus..",
  CANCEL_ALL_FIXED_CLASSES_MESSAGE: `'L'annulation de ce cours entraînera l'annulation de tous les cours énumérés ci-dessus. Si vous souhaitez annuler tous les cours fixes, sélectionnez l'option "Annuler tous les cours"'`,
  CANCEL_CLASS: "Annuler le Cours",
  CANCEL_CLASS_OUT_OF_LIMIT: "ATTENTION! Tu vas manquer le cours",
  CANCEL_DATE: "Date d'annulation",
  CANCEL_LATER_RATE: "Annulez, je l'évaluerai plus tard",
  CANCEL_MESSAGE_REPEAT: "Ce cours programmé est prêt à se répéter",
  CANCEL_MESSAGE_TICKET: "Pourquoi souhaitez-vous annuler votre billet?",
  CANCEL_MESSAGE: "Pourquoi tu veux annuler ton cours?",
  CANCEL_MESSAGE_OUT_OF_LIMIT:
    "Vous êtes sur le point d'annuler votre cours en dehors du temps imparti (1 heure), il sera donc compté comme un cours donné. Etes-vous sûr de vouloir annuler votre cours ?",
  CANCEL_MY_PLAN: "Annuler mon forfait",
  CANCEL_OPENDED_TICKET: "Annuler mon ticket ouvert",
  CANCEL_PLACEHOLDER: "Veuillez nous dire pourquoi vous souhaitez annuler votre cours",
  CANCEL_PLAN_MENSSAGEM_2:
    "Il serait précieux pour nous d'avoir votre évaluation, sur une échelle de 1 à 10, concernant votre expérience avec nos cours et notre approche pédagogique. Seriez-vous prêt à nous aider en nous fournissant ces commentaires?",
  CANCEL_PLAN_MENSSAGEM: "Nous sommes déçus d'apprendre votre départ 🙁",
  CANCEL_PLAN: "Annuler le forfait",
  CANCEL_IMMEDIATE: "Annulation immédiate",
  CANCEL_IMMEDIATE_MESSAGE: "En effectuant une annulation immédiate, l'étudiant ne pourra plus faire d'horaires.",
  CANCEL_IMMEDIATE_QUESTION: "Êtes-vous sûr de vouloir annuler immédiatement ?",
  CANCEL_TICKET: "Annuler le billet",
  CANCEL: "Annuler",
  CANCELED_CYCLE: "annulé",
  CANCELLED_LINGO: "Annulé par Lingo",
  CANCELLED: "Annulé",
  CANCELED: "Annulé",
  CANCELLED_PLAN: "Annulé Plan",
  CANCELLED_OUT_lIMIT: "Hors Limite",
  CARD_CLASS_ASSOCIATED: "Horaires Associés",
  CARD_CLASS_ATTENDED: "Le cours a-t-il été Donné?",
  CARD_CLASS_CANCEL: "Annuler l'Information",
  CARD_CLASS_CANCELLED: "Annuler la Classe",
  CARD_CLASS_CONFIRMED: "Confirmé",
  CARD_CLASS_CONTENT: "Contenu du cours",
  CARD_CLASS_COORDINATOR: "Coordinateur",
  CARD_CLASS_DETAILS: "Détails du cours",
  CARD_CLASS_DONE: "Cours terminé",
  CARD_CLASS_REASON: "Raison",
  CARD_CLASS_STUDENT: "Étudiant",
  CARD_CLASS_TEACHER: "Professeur",
  CARD_LIST_CUSTOM_SERVICE: {
    cancelled: "Annulé",
    inProgress: "En cours",
    closed: "Fermé",
    open: "Ouvert",
    companyManager: "Chef d'Entreprise",
    b2b: "B2B",
    student: "Étudiant",
    customerService: "Service Client",
    teacher: "Professeur",
    affiliate: "Affiliate",
    coordinator: "Coordinateur",
  },
  CARD_PLAN_CLASS: "Classes",
  CARD_PLAN_COURSE: "Lingo",
  CARD_PLAN_LEVEL: "Niveau",
  CARD_PLAN_SCHEDULE: "Contrôle de la Planification",
  CARD_PLAN: "Plan",
  CELLPHONE: "Téléphone mobile",
  CENCELLED_TICKET: "Votre billet a été annulé!",
  CHANCE_PICTURE: "Changer",
  CHANGE_PASSWORD_DESCRIPTION: "Définissez votre nouveau mot de passe",
  CHANGE_PASSWORD_TITLE: "Changer le Mot de Passe",
  CHANGE_PASSWORD: "Changer le Mot de Passe",
  CHANGE_PLAN: "Changer",
  CHANGE: "Changer",
  CHANGE_CARD_ERROR: "Votre carte n'est pas compatible. Veuillez essayer une autre carte.",
  CHANGE_CARD_TITLE: "Changez votre carte de crédit",
  CHECK_IN: "Check In",
  CHECK_OUR_PLANS: "Essayer gratuitement",
  CHECK_PASS_PLACEHOLDER: "Confirmer le nouveau mot de passe",
  CHECK_PASS: "Répéter le mot de passe",
  CHOOSE_LIST_TEACHER: "Choisissez une liste",
  CHOOSE_YOUR_PLAN: "Choisissez votre forfait",
  CLASS_CANCELED: "Cours annulé",
  CLASS_CANCELED_IN: "Cours annulé à",
  CLASS_CONVERTED: "Classe Convertie",
  CLASS_DETAILS_ACCESS_CLASS: "Accéder à la salle de classe",
  CLASS_DETAILS_BEFORE_CLASS: "Avant les cours",
  CLASS_DETAILS_EDIT_CLASS: "Modifier la classe",
  CLASS_LINK: "Classe",
  CLASS_RATING: "Classement",
  CLASS_SCHEDULE_EDIT_MODAL_SUBTITLE: "Édition du cours",
  CLASS_SCHEDULE_MODAL_SUBTITLE: "Planification des cours",
  CLASS_SUB_CANCELED: "Annulé",
  CLASS_SUB_CONFIRMED: "Confirmé",
  CLASS_SUB_DONE: "Fait",
  CLASS_SUB_NOSHOW: "Pas de Présentation",
  CLASS_SUB_PENDING: "En attente",
  CLASS_SUBJECT: "Entrez le sujet du cours",
  CLASS_TITLE: "Titre du cours",
  CLASS_TOOL: "Outil de classe",
  CLASS_TYPE: "Type de classe",
  CLASS: "Classe",
  CLASSES_TODAY: "Aujourd'hui tu as",
  CLASSES: "Classes",
  CLEAR_FILTERS: "Effacer les filtres",
  CLOSED_TICKET: "Votre ticket a été clôturé!",
  CLOSED: "Fermé",
  COPIED_CLIPBOARD: "Copié dans le presse-papier",
  CONFIRMED: "Confirmé",
  COMERCIAL_RESPONSIBLE_NAME: "Nom du directeur des ventes",
  COMERCIAL_RESPONSIBLE: "Responsable Commercial",
  COMMENTS: "Commentaires",
  COMMERCIAL: "Commercial",
  COMPANY_INFO: "Entreprises",
  COMPANY_MANAGER: "Chef d'Entreprise",
  COMPANY_NAME: "Nom de l'Entreprise",
  COMPANY: "Entreprise",
  COMPLEMENTARY_EXERCISES: "Exercices complémentaires",
  CONFIRM_PASS_INVALID: "Veuillez remplir votre mot de passe de confirmation!",
  CONFIRMATION: "Confirmation",
  CONTACT: "Contact",
  CONTACTS: "Contacts",
  CONTENT: "Contenu",
  MY_CONTENT: "Mon contenu",
  CONTRACT_NUMBER: "Numéro de contrat",
  CONTRACT: "Contrat",
  CONTRACTS_INFO: "Contrats",
  COORDINATED_LANGUAGES: "Lingo qui Coordonne",
  COORDINATOR: "Coordinateur",
  COPY: "Copier",
  COUNTRIES: "Pays",
  COUNTRY: "Pays",
  COUPON_INVALID: "Coupon Invalide",
  COUPON_VALID: "Coupon Valide",
  COUPON: "Coupon?",
  COUPONS_INFO: "Coupons",
  CREATOR_USER_ID: "Utilisateur",
  CURRENT_TIME: "Heure Actuelle",
  CREATE_COMMISSION: "Générer des commissions",
  CUSTOMER_SERVICE: "Service Client",
  CYCLE_NAME: "Nom du cycle",
  CYCLE: "Cycle",
  DATA_TIME: "Date et Heure",
  DATE_CHANGE_PLAN: "Ce plan sera actif le jour",
  DATE_CREATED: "Date créée",
  DATE_FORMAT: "DD/MM/YYYY",
  DATE: "Date",
  DAYS: "Jours",
  DELETE_TEACHER: "Supprimer Professeur",
  DELETE: "Supprimer",
  DEMO_CLASS_CONTENT: "Cours de Démonstration / ",
  DEMO_CLASS_CONTENT1: "Première Classe",
  DEMO_CLASS: "Cours de Démonstration",
  DEMO_TYPE: "Type de démonstration",
  DESCRIPTION_MODAL_SEND_METHOLOGY: "Contenu méthologique envoyé avec succès!",
  DESCRIPTION_MODAL_SEND_PROGRESS: "Contenu de Progression Académique envoyé avec succès!",
  OLD_DESCRIPTION_PLAN_EXPIRED:
    "Votre période d'essai est terminée! Achetez un nouveau forfait en cliquant sur le bouton ci-dessous!",
  DESCRIPTION: "Description",
  DICTATION: "Dictation",
  DOCUMENT_NUMBER: "ID de l'Entreprise",
  DONE: "Fait",
  DONT_HAVE_ACTIVE_PLAN: "Oh no! Vous n'avez pas de forfait actif 🙁",
  DOUBLE_CLICK: "Double-cliquez pour changer",
  DOWNLOAD_APP: "Êtes-vous sur votre téléphone? Téléchargez notre application. Cliquez ci-dessous!",
  DURATION: "Durée",
  ECONOMIC_GROUP: "Groupe Economique",
  EDIT_COMPANY: "Modifier l'entreprise",
  EDIT_CLASS: "Modifier",
  EDIT_CONTENT: "Modifier le contenu",
  EDIT: "Modifier",
  EMAIL_ERROR: "E-mail Incorrecte",
  EMAIL_INVALID: "E-mail Invalide, veuillez vérifier!",
  EMAIL_PLACEHOLDER: "Votre e-mail",
  EMAIL_REQUIRED: "E-mail Invalide, veuillez vérifier!",
  EMAIL: "E-mail",
  END_TIME: "Heure de fin",
  END: "Fin",
  ENGLISH: "Anglais",
  ENTER_COUPON_PLACEHOLDER: "Entrer le coupon",
  ENTER_NAME: "Enter le Nom",
  ENTER_PERCENTAGE_VALUE: "Entrer % Valeur",
  ENTER_TICKET: "Entrer le Ticket",
  ERROR_DIALOG: "Quelque chose s'est mal passé, réessayez plus tard.",
  EXCEPTION_TEACHER: "Exception",
  EXCLUSION_LEVELS: "Niveaux d'exclusion",
  EXPIRED_ON: "A expiré le",
  EXPIRES_ON: "Expires on",
  EXTRA_CLASS_PRICE: "Prix ​​​​de Classe Supplémentaire",
  EXTRA_CLASS_USED_PLURAL: "Cours supplémentaires utilisés",
  EXTRA_CLASS_USED_SINGLE: "Classe supplémentaire utilisée",
  EXTRA_CLASS: "Classe Supplémentaire",
  EXTRA_CLASSES: "classes supplémentaires",
  EXTRA_EMAIL_PLACEHOLDER: "Un autre e-mail",
  EXTRA_EMAIL: "E-mail alternatif",
  FAVORITE_TEACHER: "Préféré",
  FEMALE: "Femelle",
  FIELD_IS_REQUIRED: "Le champ {{fieldName}} est obligatoire",
  FILTER: "Filtrer",
  FILTERS: "Filters",
  FINAL_TEST: "Examen final",
  FIRST_ACESS_TEXT_B2B:
    "Avant de commencer les cours, veuillez compléter votre inscription et définir un nouveau mot de passe",
  FIRST_ACESS_TEXT: "Avant de commencer les cours, veuillez compléter votre inscription",
  FIRST_CLASS: "Première classe",
  FOCUS: "Contenu",
  FORGET_TITLE: "Récupérer mot de passe",
  FORGOT_PASS: "Mot de passe oublié?",
  FRENCH: "Français",
  FREE: "Gratuit",
  GENDER: "Sexe",
  GENERATE_REPORT: "Générer un Rapport",
  GRADES: "Grades",
  GROUP: "Groupe",
  HAVE_ACCOUNT: "Avoir un compte?",
  HISTORY: "Historique",
  HOME: "Acceuil",
  HOURS: "Heures",
  HOW_MANY_CLASSES: "Combien de classes",
  I_AGREE: "I agree with the",
  I_WANT_TO_SCHEDULE_MY_CLASSES: "Je veux programmer mes cours",
  IN_PROGRESS: "En Cours",
  IN_STOCK: "en stock",
  IN_THIS_TIMEZONE: "Dans ce Fuseau horaire",
  INACTIVE: "Inactif",
  INDEX_KEY_ERROR: "fr_FR",
  INDEX_KEY_STRING: "nameFrench",
  INTERMEDIATE: "Intermédiaire",
  INVALID_FORM_DESCRIPTION: "Remplissez les informations requises et réessayez.",
  INVALID_FORM_TITLE: "Alerte!",
  INVOICE: "Facture",
  OLD_IS_MAJOR: "Avez-vous plus de 18 ans?",
  ISACTIVE: "Actif",
  ITEM_ACCOUNT: "Mon Compte",
  ITEM_CUSTOMER_SERVICE: "Service Client",
  ITEM_SCHEDULE: "Calendrier",
  ITEM_STUDENTS: "Etudiants",
  ITEM_TEACHERS: "Professeurs",
  LANGUAGE_KEY_STRING: "anglais",
  LANGUAGE_LEVEL: "Niveau de langue",
  LANGUAGE: "Langue",
  LANGUAGES: "Langues",
  LAST_INTERACTION: "Dernière Interaction",
  LEGAL_NAME: "Nom Légal",
  LEVEL_BY_STUDENT: "Niveau par Elève",
  LEVEL_SCORE: "Niveau et Notes",
  LEVEL: "Niveau",
  LEVELS: "Niveaux",
  LINGO_ADV: "Avancé",
  LINGO_EMAIL: "E-mail Enregistré",
  LINGO_INTER: "Intermédiaire",
  LINGO: "Lingo",
  LINK_SUBSCRIPTION: "https://www.lingofor.me/lingo-us/lingo_aula_demo.html",
  LOAD_MORE: "Voir plus",
  LOCAL_CLASS_TIME: "Heure de cours locale",
  LOCALE: "en-us",
  LOGIN_EMAIL: "Pseudo E-mail",
  LOGIN_SUBS: "S'inscrire",
  LOGOUT: "Se déconnecter",
  MALE: "Male",
  MANAGE: "Gérer Plan",
  MANAGE_ACCOUNT_TITLE: "Gérer son Compte",
  MANAGE_HOURS_NOTIME: "Aucun créneau horaire disponible pour planifier ce jour",
  MANAGE_HOURS_TITLE: "Ajoutez vos créneaux horaires disponibles pour chaque jour de la semaine",
  MAXIMUM_STUDENTS: "La limite maximale d’étudiants par plan atteinte",
  MESSAGE_BACK_RESET_CYCLE: "Les tâches sont asynchrones et peuvent prendre quelques minutes pour se terminer.",
  MESSAGE_EDIT: "Mis à jour",
  MESSAGE_INFO_BILINGUE_NATIVO: `By selecting "Native" tous vos nouveaux horaires de cours d'anglais seront avec des professeurs natifs. En sélectionnant "Bilingue", vous aurez des professeurs bilingues.
.`,
  MESSAGE_INFO_CONTENT_REGULAR: `Régulier: Le professeur suivra notre méthodologie et notre matériel qui vous permettront d'avancer dans nos différents niveaux d'études.`,
  MESSAGE_INFO_CONTENT_SPECIFIC: `Spécifique: Le professeur pourra vous aider avec tout matériel que vous fournirez et ainsi vous pourrez clarifier des doutes spécifiques, par exemple, rédiger un e-mail, comprendre un document, etc.`,
  MESSAGE_INFO_REPEAT: `Dans cette option, vous pouvez répéter la programmation en sélectionnant les jours et jusqu'à quelle date vous souhaitez que la programmation soit répétée.`,
  MESSAGE_CONFIRM_CHANGE_CLASS:
    "Votre cours commençant dans moins d'une heure, toute modification effectuée à ce stade est considérée comme une annulation tardive. Si vous continuez : Votre cours actuel sera annulé et déduit de vos crédits mensuels. Le nouveau créneau sera réservé comme session supplémentaire.",
  MESSAGE_LANGUAGE: "en_US",
  MESSAGE_MODAL_VERSION:
    "Nous avons une nouvelle mise à jour de l'application et nous devons vous déconnecter afin de l'appliquer. Veuillez vous reconnecter.",
  MESSAGE_RESET_CYCLE: "Voulez-vous vraiment réinitialiser les cycles?",
  MESSAGE_SAVE: "Inscrit",
  METHODOLOGY: "Méthodologie",
  MODAL_RELOAD_MESSAGE: "Vous avez modifié votre fuseau horaire, veuillez vous reconnecter!",
  MODAL_RELOAD_SUBJECT: "Fuseau horaire modifié",
  MODAL_RELOAD_SUBJECT_TIME: "Format d'horaire modifié",
  MODAL_RELOAD_MESSAGE_TIME: "Veuillez vous reconnecter",
  MODULE: "Planification",
  MONEY_FORMAT: "U$",
  MONTHLY: "par mois",
  MULTYPLE_CLASSES_MESSAGE:
    "Ce cours fait partie d'un planning de cours multiples. En l'acceptant, vous serez affecté à l'intégralité de la séquence:",
  MULTYPLE_CLASSES: "COURS MULTIPLES",
  NAME_PLACEHOLDER: "Votre nom",
  NAME_REQUIRED: "Veuillez remplir votre nom!",
  NAME: "Nom",
  NATIVE_LANGUAGE: "Langue Native",
  NATIVE: "Native",
  NEW_BTN_RESET_CYCLE: "Réinitialisation du cycle",
  NEW_CONTENT: "Nouveau contenu",
  NEW_USER: "Non enregistré?",
  NEW: "Nouveau",
  NIVEL_A0: "Débutant",
  NIVEL_A1: "Pré-élémentaire",
  NIVEL_A2: "Elémentaire",
  NIVEL_B1: "Intermédiaire",
  NIVEL_B2: "Intermédiaire Supérieur",
  NIVEL_C1: "Avancé",
  NIVEL_C2: "Compétence",
  NIVEL_DM: "Maintenance",
  INTERVIEW: "Entretien",
  NO_NOTIFICATIONS: "Aucune Notification",
  NO_RESULTS: "Aucuns Résultats",
  NO_THANKS: "Non Merci",
  NO: "Non",
  NOSHOW_MESSAGE_MODAL: "La classe va changer de statut en {{status}}, voulez-vous continuer?",
  NOSHOW: "Pas de Présentation",
  NOT_AUTHORIZED: "Connexion non autorisée",
  NOT_INFORMED: "Pas Informé",
  NOT_REGISTERED: "Non enregistré? ",
  NOTES_HISTORY: "Historique des Notes",
  NOTIFICATION_SETTINGS: "Paramètres des Notifications",
  NOTIFICATION_TITLE: "Contrôler où vous recevez les notifications de Lingo:",
  NOTIFICATION: "Notifications",
  NOTIFICATIONS: "Notifications",
  O_K: "Ok",
  OBSERVATION: "Observation",
  OCCUPATION: "Profession",
  OOOPS_CANCEL_MY_PLAN: "Ooops! Je ne veux pas annuler mon forfait",
  OOOPS_DONT: "Ooops! Je ne veux pas annuler mon billet ",
  OPEN_DATE: "Date d'ouverture",
  OPEN_NEW_TICKET: "Ouvrir un Nouveau Billet",
  OPEN: "Ouvrir",
  OPTION_CORRECTIONS_RATING_COMMENTS: "Seulement, je lis sans interaction",
  OPTION_EXPLAIN_RATING_COMMENTS: "Parle excessivement ma langue maternelle",
  OPTION_EXPRESSION_RATING_COMMENTS: "Des explications peu claires rendent la compréhension difficile",
  OPTION_LOUD_RATING_COMMENTS: "Je ressens une meilleure connexion avec les autres",
  OPTION_OTHER_RATING_COMMENTS: "Autres",
  OPTION_TALK_RATING_COMMENTS: "Parle vite et ne corrige pas les erreurs",
  OPTIONS: "Options",
  OR_LOGIN_TXT: "ou connectez-vous avec",
  OR_LOGIN: "ou connectez-vous avec",
  ORAL: "Oral",
  ORDER_COMPLETE: "Confirmation",
  ORDER_DETAILS: "Détails de la commande",
  ORDER_REVIEW: "Examiner et Payer",
  ORDER: "Commander",
  OTHER_LANGUAGE: "Autre Langue",
  OTHER_LANGUAGES: "Autres langues",
  PARAMETERS: "Paramèters",
  PASS_ERROR: "Champs requis",
  PASS_INVALID_MESSAGE:
    "Mot de passe incorrect! Minimum de six caractères, au moins une lettre, un chiffre et un caractère spécial comme @$!%*#?&[]{},.;<>:/~^´`-_() !",
  PASS_INVALID: "Veuillez remplir votre mot de passe!",
  PASS_NOT_MATCH: "Votre mot de passe et votre mot de passe de confirmation ne correspondent pas, veuillez vérifier!",
  PASS_NOTEQUAL_MESSAGE: "Les Champs du mot de passe doivent être égaux",
  PASS_PLACEHOLDER: "Votre mot de passe",
  PASSWORD_CHANGE: "Le mot de passe a été changé avec succès!",
  PASSWORD_CONFIRM: "Confirmez le mot de passe",
  PASSWORD_ERROR: "Nom d'utilisateur ou mot de passe incorrect",
  PASSWORD_NOT_MATCH: "Les mots de passe doivent être identiques",
  PASSWORD: "Mot de passe",
  PAYMENT_ID: "Identifiant de paiement",
  PAYMENT_METHOD: "Mode de paiement",
  PAYMENT: "Paiement",
  PENDING: "En attente",
  PER_MONTH: "un mois",
  PERIOD_END: "Période - fin",
  PERIOD_START: "Période - début",
  PERIOD: "Période",
  PERSONAL_DATA: "Informations Personnelles",
  PERSONAL_INFO: "Informations Personnelles",
  PERSONAL_INFORMATION: "Informations Personnelles",
  PHONE_PLACEHOLDER: "Téléphone",
  PHOTO: "Photo",
  PLAN_BALANCED: "Equilibré",
  PLAN_BUSINESS: "Entreprise",
  PLAN_BUY: "Acheter un forfait",
  PLAN_CONVERSATIONAL: "De la conversation",
  PLAN_DOWNGRADE: "Téléchargez mon forfait",
  PLAN_GRAMMAR: "Grammaire",
  PLAN_NOT_FOUND: "Plan introuvable",
  PLAN_RENOVATION: "Annulation inversée",
  PLAN_RENOVATION_MESSAGE:
    "Lors de l'annulation de l'annulation, le système poursuivra la facturation mensuelle automatique pour votre prochaine période de cours.",
  PLAN_TRADITIONAL: "Traditionnel",
  PLAN_UPGRADE: "Augmenter mon forfait",
  PLAN: "Forfait",
  PLANS_AND_PRICING: "Forfaits et Prix",
  PLANS: "Forfaits",
  PLEASE_TELL_CANCEL_MESSAGE_TICKET: "Veuillez nous indiquer pourquoi vous souhaitez annuler votre billet",
  PORTUGUESE: "Portuguais",
  POWER: "Pouvoir",
  PRICE_IN: "Prix en USD",
  PROCEED_TO_PAYMENT: "Procéder au Paiement",
  PROFILE: "Profile",
  PROVIDER: "Fournisseur",
  PUSH: "Pousser",
  PUSH_GENERATOR: "Générateur de poussée",
  RANDOM: "Aléatoire",
  RATE: "Evaluer",
  RATING_AVG_INFO: "Notation",
  RATING_CONFIRMED: "Evalué",
  RATING_DESCRIPTION_TEACHER: "Souhaitez-vous avoir plus de cours avec ce professeur?",
  RATING_INFO_PLURAL: "En attente",
  RATING_INFO_SINGULAR: "En attente",
  RATING_MODAL_TITLE: "Veuillez noter les cours suivants",
  RATING_PENDING_INFO_PLURAL: "notes",
  RATING_PENDING_INFO_SINGULAR: "notation",
  RATING_PENDING: "En attente",
  RATING: "Notation",
  REAL_LEVEL: "Niveau Réel",
  REFER_YOUR_FRIENDS_AND_EARN: "Le programme Indiquer et Gagner a atteint un nouveau record de paiement !",
  REFUND: "Remboursement",
  REFUND_MESSAGE: "Lors d'un remboursement, l'étudiant recevra le remboursement de son dernier paiement.",
  REFUND_QUESTION: "Êtes-vous sûr de vouloir effectuer le remboursement ?",
  REMEMBER_ACCESS: "Souviens-toi de moi",
  REPEAT: "Voulez-vous répéter ce programme les autres jours?",
  REPORT: "Rapport",
  REQUESTED_PLAN: "Plan Demandé",
  REQUIRED_FIELD: "Requis",
  REQUIRED: "Requis",
  RESET_CYCLE: "au prochain cycle de redémarrage",
  RESETS_ON: "Réinitialise sur",
  RESIDENCIAL: "Résidentiel",
  RESEND: "Renvoyer",
  REVIEW_AND_PAY: "Réviser et Payer",
  REVIEW_INFORMATION: "Vérifiez vos Informations",
  REVIEW_PLAN: "Révisez votre forfait ",
  REVIEW_YOUR: "Vérifier Votre ",
  SAVE_FORM_DESCRIPTION: "Informations enregistrées avec succès!",
  SAVE_FORM_TITLE: "Succès!",
  SAVE: "Enregistrer",
  SCHEDULE: "Calendrier",
  SCHEDULING_CONTROL: "Contrôle de la Planification",
  SEARCH_USER: "Rechercher un utilisateur",
  SELECT_LANGUAGE_LEVEL: "Veuillez indiquer votre niveau de langue!",
  SELECT_LANGUAGE_PLAN_TITLE: "Sélectionnez un plan linguistique",
  SELECT_LANGUAGES: "Veuillez remplir votre langue!",
  SELECT_TEACHER: "Sélectionnez un professeur",
  SELECT_TIME_FORMAT: "Sélectionnez le format du planning",
  SELECT_TIMEZONE: "Choisissez le Créneau Horaire",
  SELECT_THE_LINK: "Sélectionnez le lien que vous souhaitez envoyer:",
  SELECT: "Sélectioner",
  SEND: "Envoyer",
  SEQUENTIAL_CLASS_MESSAGE: "Cette classe fait partie de la séquence de classes suivante:",
  SETTINGS_NOTIFY: "Paramètres de Notification",
  SETTINGS: "Notifications",
  SHARE: "Suivez-nous",
  SHCEDULING_IN: "Planification",
  SHOWING_OF: "de",
  SHOWING: "Affichage",
  SIGN_UP: "Consultez nos Forfaits",
  SIGNATURE_DATE: "Date de la signature",
  SIGNATURE_PENDING: "Signature en attente",
  SINCE: "Depuis",
  SING_IN: "Se connecter",
  SOCIAL_MEDIA: { LOGIN_ERROR: "Échec de la connexion" },
  SOMETHING_WENT_WRONG: "Quelque chose s'est mal passé",
  SPANISH: "Espagnol",
  START_TIME: "Heure de début",
  START: "Commencer",
  STATUS_CHANGE: "Changement de Statut",
  STATUS: "Statut",
  STRUCTURE: "STRUCTURE",
  STUDENT_ADDRESS: "Adresse de l'Etudiant",
  STUDENT_COMPANY_NAME: "Nom de l’Entreprise Etudiante",
  STUDENT_COMPANY: "Nom de l'Entreprise",
  STUDENT_EMAIL: "Courriel de l'Etudiant ",
  STUDENT_LINK: "Lien Etudiant",
  STUDENT_MESSAGE_EDIT: "Étudiant Mis à Jour",
  STUDENT_MESSAGE_SAVE: "Étudiant Inscrit",
  STUDENT_NAME: "Nom de l'Etudiant",
  STUDENT_OCCUPATION: "Poste d'Étudiant",
  STUDENT_PHONE: "Téléphone Étudiant",
  STUDENT_TOOL_ID: "Carte d'Étudiant",
  STUDENT: "Étudiant",
  STUDENTS_TIMEZONE: "Fuseau Horaire des étudiants",
  STUDENTS: "Étudiants",
  SUBSCRIPTION: "Abonnement",
  SUBSCRIPTION_DATE: "Date de Souscription",
  SUBTYPE: "Sous-type",
  SUCCESS_MESSAGE: "Succès!",
  SUCCESS_CHANGE_CARD: "Votre carte a été mise à jour, le prochain paiement en sera déduit.",
  SUCESS_CANCEL_PLAN:
    "Votre forfait a été annulé. Vous pouvez planifier des cours jusqu'à la fin de votre cycle de facturation.",
  SUCESS_CANCEL_PLAN_MANAGE: "Forfait a été annulé.",
  SWARMING_TITLE: "Calendrier de Forte Demande",
  TARGET_CLASSES_PER_MONTH: "Cours cibles par mois",
  TEACHER_AVERAGE_RATING: "Note Moyenne des Enseignants",
  TEACHER_LINK: "Lien du professeur",
  TEACHER_NAME: "Nom de l'enseignant",
  TEACHER_TYPE: "Type d'enseignant",
  TEACHER: "Enseignant",
  TEACHERS: "Enseignants",
  TEL_REQUIRED: "Téléphone portable Invalide, veuillez vérifier!",
  TELEPHONE_COMMERCIAL: "Téléphone Commercial",
  TELEPHONE_MOBILE: "Téléphone Mobile",
  TELEPHONE: "Téléphone",
  TELL_US_CANCEL_MY_PLAN: "Veuillez nous dire pourquoi vous souhaitez annuler votre forfait",
  TERMS_OF_USE: "Contrat d'Apprentissage en Ligne",
  TERMS_OF: "conditions d'utilisation ",
  THIS_PLAN: "Ce plan sera",
  TICKET_ID: "Billet #",
  TICKET_MESSAGE: "Votre ticket a été ouvert",
  TICKET_NUMBER: "Numéro de billet",
  TICKET_TITLE: "Félicitations!",
  TICKET_VIEW: "Voir le billet",
  TICKETS: "Billets",
  TIME_SLOT_DURATION: "Durée du créneau horaire",
  TIMEZONE: "Fuseau horaire",
  TITLE_CONFIRM_CHANGE_CLASS: "Remarque importante : Politique de report tardif",
  TITLE_MODAL_SEND: "Succès!",
  TITLE_MODAL_VERSION: "Nouvelle version disponible!",
  TITLE_PLAN_EXPIRED: "Votre forfait a expiré!",
  TITLE: "Titre",
  TODAY: "Aujourd'hui",
  TOOL_ID: "ID de l'outil",
  TOTAL_CLASSES: "Classes totales",
  TOTAL_CYCLES: "Cycle total",
  TOTAL_QUIZZES: "Total des quiz",
  TRAINING: "Entraînement",
  TRANSACTION_ID: "Identifiant de transaction",
  TRIAL_CLASS: "Cours d'Essai",
  TRY_AGAIN: "Essayer à Nouveau",
  TYPE_MESSAGE: "Tapez un message...",
  TYPE: "Taper",
  UNITARY_VALUE: "Valeur unitaire",
  UNTIL: "Jusqu'à",
  UPDATE_SCREEN: "Mise à jour",
  USER_INFO: "Vos informations",
  USERS: "Utilisateurs",
  VALID_FORM_DESCRIPTION: "Le mot de passe a été changé avec succès!",
  VALID_FORM_TITLE: "Succès",
  VALIDATE_SCHEDULE_DATE_PAST: "Le cours ne peut pas être passé",
  VALIDATE_SCHEDULE_DATE: "La date est requise",
  VALIDATE_SCHEDULE_FOCUS: "Le contenu est requis",
  VALIDATE_SCHEDULE_LANG: "La langue est requise",
  VALIDATE_SCHEDULE_NATIVE_BILINGUE:
    "L'option natif/bilingue n'a pas été sélectionnée, il faut choisir le type d'enseignant pour cette classe",
  VALIDATE_SCHEDULE_NUM_CLASSES: "Le nombre de cours est requis",
  VALIDATE_SCHEDULE_PLAN: "Le Plan est requis",
  VALIDATE_SCHEDULE_REPEATEND: "Répétez jusqu'à ce que cela soit requis",
  VALIDATE_SCHEDULE_START: "L'heure de début est requise",
  VALIDATE_SCHEDULE_WEEKREPEAT: "Au moins un jour de la semaine est requis",
  VALIDATE: "Valider",
  VALIDATION_ERROR: "Erreur de validation",
  VALUE: "Valeur",
  VIEW_MORE: "Voir Plus",
  VIEW: "Voir",
  VIEW_CONTRACT: "Voir le contrat",
  WEBSITE: "Site web",
  WEEK_FRIDAY: "Vendredi",
  WEEK_MONDAY: "Lundi",
  WEEK_SATURDAY: "Samedi",
  WEEK_SUNDAY: "Dimanche",
  WEEK_THURSDAY: "Jeudi",
  WEEK_TUESDAY: "Mardi",
  WEEK_WEDNESDAY: "Mercredi",
  WELCOME_TITLE: "Bienvenue à ",
  WHAT_TYPE_OF_TEACHER: "Quel type d'enseignant souhaitez-vous avoir dans cette classe?",
  WHATSAPP: "WhatsApp",
  WHATSAPP_SUPPORT: "Assistance WhatsApp",
  WITHOUT_TEACHER: "Sans Professeur",
  WORDOFTHEDAY: "Mot du jour",
  WRITING: "Ecriture",
  YES: "Oui",
  YOUR_EXTRA_CLASSES_IS_ALL_SET: "Vos cours supplémentaires sont prêts",
  YOUR_PLAN: "Votre plan sera",
  YOUR_TIMEZONE: "Votre Fuseau horaire",

  PRODUCTIVITY: "Productividad",
  SALES_LINK: "Link de Ventas",
  DISCLOSURE: "Divulgación",
  TRANSACTIONS: "Transacciones",
  CONTRACTS: "Contratos",
  BRONZE: "Bronce",
  BLUE: "Blue",
  GOLD: "Gold",
  SILVER: "Silver",
  PLATINUM: "Platinum",
  SALES: "ventas",
  SALES1: "Ventas",
  PRIVILEGE: "Privilegio",
  PRIVILEGES: "Privilegios",
  CONTRACT_PENDING: "Tu contrato está pendiente",
  MONTHLY_PRIVILEGES: "Los privilegios son mensuales.",
  PRODUCTIVITYINFO1: "Necesitas",
  PRODUCTIVITYINFO2: "ventas para alcanzar el nivel",
  MY_TRANSACTIONS: "Mis transacciones",
  MY_COMMISSION: "Mi comisión",
  MINIMUM_WITHDRAWAL1: "Mínimo de",
  MINIMUM_WITHDRAWAL2: "para retiro",
  VISITS: "Visitas",
  DEMOS: "Demos",
  CONVERSIONS: "Conversiones",
  FLAT: "Plan",
  TOTAL: "Total",
  MENU: "Menú",
  MY_SALES_LINK: "Mi link de ventas",
  SHORT_LINK: "Link corto",
  SHARE_SOCIAL_NETWORKS: "Comparte en las redes sociales",
  LINK_COPIED: "Enlace copiado al portapapeles.",
  MESSAGE_SHARE: "teste mensagem lingo",
  CURRENT_BALANCE: "Saldo actual",
  CONCLUDED: "Concluido",
  WITHDRAWAL: "Retirado",
  PAYMENTO_LINGO: "Pago de Lingo",
  COMMISSION: "Comisión",
  CONVERSION: "Conversión",
  SUBTITLE: "Leyenda",
  SUBTITLE_COMMISSION: "Valor vs Tiempo",
  SUBTITLE_CONVERSION: "Ventas vs tiempo",
  AFFILIATE: "Affiliate",
  AFFILIATES: "Affiliates",
  ADD_PROFILE_PHOTO: "Add a profile photo.",
  ADD_TAX_INFORMATION: "Ajoutez vos informations fiscales.",
  ADD_PAYMENT_INFORMATION: "Select a payment method",
  TERMS_OF_USE_AFFILIATE: "Terms of use",
  BTN_ACCEPT: "Accept",
  PROFILE_PICTURE: "Profile photo",
  SUCCESS_MESSAGE_PHOTO: "Your photo has been added successfully!",
  PAYMENT_METHOD_LABEL: "Enter the method and user of the account",
  SUCCESS_MESSAGE_PATMENT_METHOD: "Your payment details have been added successfully!",
  FISCAL_DOCUMENT: "Quel est votre document fiscal ?",
  OTHER: "Autre",
  BRAZILIAN_ADDRESS: "Adresse brésilienne",
  AMERICAN_ADDRESS: "Adresse américaine",
  ADRESSE_COLOMBIENNE: "Adresse colombienne",
  ADRESSE_MEXICAINE: "Adresse mexicaine",
  ALERT_TAX_INFORMATION:
    "Important : Vous avez sélectionné l'option pour les résidents fiscaux américains. Toutes les informations doivent être vérifiées car elles serviront à générer 1099",
  SUCCESS_MESSAGE_TAX_INFORMATION:
    "Les informations ont été enregistrées de manière satisfaisante, le contrat a été envoyé à votre email prêt à être signé.",
  ALERT_MESSAGE_TAX_INFORMATION: "Le contrat a été envoyé à votre email prêt à être signé.",
  TAX_INFORMATION: "Informations fiscales",
  CITY: "Ville",
  STATE: "État",
  ZIPCODE: "Code postal",
  CITIZENSHIP_COUNTRY: "De quel pays êtes-vous citoyen ?",
  WHERE_LIVE_COUNTRY: "Dans quel pays résidez-vous ?",
  MODAL_PAYAMENT_ALERT01:
    "Saisissez l'e-mail que vous utilisez pour vous connecter à la passerelle de paiement sélectionnée. ",
  MODAL_PAYAMENT_ALERT02: "Important: ",
  MODAL_PAYAMENT_ALERT03:
    " vous devez vérifier votre courrier électronique, car une fois le paiement traité, nous ne pouvons pas demander de remboursement.",
  SALES_LINK_PT: "Link in Portuguese",
  SALES_LINK_ES: "Link in Spanish",
  SALES_LINK_US: "Link in English",
  BONUS: "Prime",
  CORPORATE_NAME: "Company name",
  COMMUNICATION_LANGUAGE: "Communication Language",
  PHYSICAL_PERSON: "Natural Person",
  LEGAL_PERSON: "Legal Entity",
  AFFILIATE_PROGRAM_TITLE: "Affiliate program ($)",
  AFFILIATE_PROGRAM_DESCRIPTION: "Sign up for free and start receiving!",
  BE_AFFILIATED: "Indiquer et gagner",
  PAID: "Payé",
  NO_ITEMS_FOUND: "Aucun élément trouvé...",
  TOTAL_LIFETIME_COMMISSION: "Commission totale à vie",
  PAY_ALL: "Payer tout",
  MODAL_AFFILIATE_STUDENT_TITLE1: "Earn up to ",
  MODAL_AFFILIATE_STUDENT_TITLE2: "$ 75.20 dollars",
  MODAL_AFFILIATE_STUDENT_TITLE3: "per plan referred",
  MODAL_AFFILIATE_STUDENT_SUBTITLE1: "Be one of the first Lingofor.me affiliates",
  MODAL_AFFILIATE_STUDENT_SUBTITLE2: "Generate extra income in dollars!",
  MODAL_AFFILIATE_STUDENT_BUTTON: "Get started now!",
  MODAL_AFFILIATE_STUDENT_CARD_TITLE1: "1 - Share your referral link",
  MODAL_AFFILIATE_STUDENT_CARD_TITLE2: "2 - Demo class scheduling",
  MODAL_AFFILIATE_STUDENT_CARD_TITLE3: "3 - Receive the commission in dollars",
  MODAL_AFFILIATE_STUDENT_CARD_SUBTITLE1: "Share your exclusive referral link with friends, family and colleagues.",
  MODAL_AFFILIATE_STUDENT_CARD_SUBTITLE2:
    "Every student referred to the course can schedule a free trial class to get to know the method and the platform.",
  MODAL_AFFILIATE_STUDENT_CARD_SUBTITLE3: "Earn commission of up to $75.20 for each successful referral.",
  ITEM_CARD_AFFILIATE1: "Payment in Dollars.",
  ITEM_CARD_AFFILIATE2:
    "Earn up to $75.20 for every referral that purchases a plan using your exclusive referral link.",
  ITEM_CARD_AFFILIATE3: "Biweekly payments.",
  ITEM_CARD_AFFILIATE4: "The more people you refer, the greater the possibility of contracted plans.",
  ITEM_CARD_AFFILIATE5: "Refer in any country, we have students in more than 34 countries.",
  ITEM_CARD_AFFILIATE6: "More than 400,000 classes held on the platform.",
  ITEM_CARD_AFFILIATE7: "Excellent student feedback",
  ITEM_CARD_AFFILIATE8: "All plans are multilingual",
  ITEM_CARD_AFFILIATE9: "Monthly plans and no cancelation penalty for students",

  JANUARY: "Janvier",
  FEBRUARY: "Février",
  MARCH: "Mars",
  APRIL: "Avril",
  MAY: "Mai",
  JUNE: "Juin",
  JULY: "Juillet",
  AUGUST: "Août",
  SEPTEMBER: "Septembre",
  OCTOBER: "Octobre",
  NOVEMBER: "Novembre",
  DECEMBER: "Décembre",
  JAN: "Jan",
  FEB: "Fév",
  MAR: "Mar",
  APR: "Avr",
  JUN: "Juin",
  JUL: "Juil",
  AUG: "Aoû",
  SEP: "Sep",
  OCT: "Oct",
  NOV: "Nov",
  DEC: "Déc",

  CREATE_YOUR_ACCOUNT: "Create your account",
  NAME_FULL: "Full Name",
  BTN_NEXT: "Next",
  SELECT_COUNTRY: "Select your country",
  REVIEW_SUBSCRIPTION_TITLE: "Review subscription",
  ABBREVIATED_DISCOUNT: "Disc.",
  REVIEW_SUBSCRIPTION_TEXT1: "Your plan renews monthly automatically.",
  REVIEW_SUBSCRIPTION_TEXT2: "You can cancel automatic renewal at any time.",
  REVIEW_SUBSCRIPTION_TEXT3: "The monthly fee for the chosen plan is",
  REVIEW_SUBSCRIPTION_TEXT4: "which will be charged monthly according to the day of registration.",
  PRIVACY_TERMS_TEXT: "I agree to the automatic renewal terms above.",
  ALL_OUR_PLANS: "All our plans are multilingual",
  SIGN_FOR_LINGO: "By signing up with Lingo, you agree to the terms above and our",
  PRIVACY_POLICY: "Privacy Policy.",
  BTN_BUY: "Buy",
  THANKS: "Thank you!!",
  A_PARTNER: "A partner:",
  WELCOME_TO_LINGO: "Your plan purchase was completed successfully! Welcome to Lingo!",
  WELCOME_TO_LINGO_CHANGE: "L’achat de votre plan a été finalisé avec succès !",
  BTN_MANAGR_ACCOUNT: "Access my user",
  MINUTE_CLASSES_MONTH: "30-minute classes per month",
  ITEM_CARD_INFO1: "Multilingual plans",
  ITEM_CARD_INFO2: "Private classes with live teachers",
  ITEM_CARD_INFO3: "Practical classes focused on conversation.",
  ITEM_CARD_INFO4: "Free scheduling (24/7)",
  ITEM_CARD_INFO5: "No registration fee, materials or penalty for cancelation.",
  ITEM_CARD_INFO6: "Monthly and automatic invoicing.",
  ITEM_CARD_INFO7: "Classes are not cumulative for a subsequent period",
  ITEM_CARD_INFO8: "Apps for",
  INVALID_PASS1: " At least 6 characters",
  INVALID_PASS2: " At least 1 letter",
  INVALID_PASS3: " At least 1 number",
  INVALID_PASS4: " At least 1 special character ",
  INVALID_PASS5: " Passwords must be the same.",
  INVALID_FORM_CHECKOUT1: "The name is mandatory!",
  INVALID_FORM_CHECKOUT2: "The email is mandatory!",
  INVALID_FORM_CHECKOUT3: "The email is invalid!, please check your email.",
  INVALID_FORM_CHECKOUT4: "The cell phone number is mandatory!",
  INVALID_FORM_CHECKOUT5: "Country selection is mandatory!",
  INVALID_FORM_CHECKOUT6: "You must agree to the privacy terms to continue.",
  INVALID_FORM_CHECKOUT7: "The user",
  INVALID_FORM_CHECKOUT7_1: " already exists, click the login button to enter your account.",
  INVALID_FORM_CHECKOUT8: "Unable to load plan information, please try later.",
  INVALID_FORM_CHECKOUT9: "Le champ de la raison sociale est obligatoire",
  INVALID_FORM_CHECKOUT10: "La date de naissance est obligatoire!",
  INVALID_FORM_CHECKOUT11: "Vous devez avoir plus de 18 ans pour vous inscrire!",
  INVALID_FORM_CHECKOUT12: "Le champ de langue est obligatoire",
  INVALID_FORM_CHECKOUT13: "Veuillez compléter le reCAPTCHA!",

  SAME: "Same",
  BEST_SELLER: "Best Seller",
  CARD: "Card",
  NEW_CARD: "Enter a new card as a payment method.",
  NEXT_CYCLE: "Your subscription will change at the next payment cycle renewal.",
  ACTIVATION: "Activation",
  SCHEDULED: "Scheduled",
  IMMEDIATE: "Immediate",
  CHANGE_NOW: "Your subscription will be changed to the new plan right now.",

  NEW_MULTI_STUDENT: "NOUVELLES",
  SUBTITLE01: "Désormais votre forfait est MULTI-LANGUES",
  SUBTITLE02: "Étudiez l'anglais, l'espagnol, le portugais et le français (à venir), sans payer plus cher!",

  TITLE_ALERT_NEWS: "Nouvelle mise à jour",
  SUBTITLE01_ALERT_NEWS: "Dites adieu aux post-it et aux vérifications interminables de votre emploi du temps ! 🚀",
  SUBTITLE02_ALERT_NEWS:
    "Notre toute nouvelle mise à jour est arrivée : intégration complète avec Google Agenda. Désormais, vos cours s'affichent automatiquement dans votre agenda dès que vous créez un nouveau rendez-vous.",
  SUBTITLE03_ALERT_NEWS: "✅ Plus jamais d'oublis",
  SUBTITLE04_ALERT_NEWS: "✅ Tout est centralisé",
  SUBTITLE05_ALERT_NEWS: "✅ Mises à jour en temps réel",
  SUBTITLE06_ALERT_NEWS:
    "Essayez-le dès aujourd'hui ! Rendez-vous dans « Mon compte » > Notifications et connectez votre compte Google à Lingo.",

  REPORT_FORM: "Rapport",
  CLASSES_HELD: "Contenu donné",
  CLASS_COMMENTARY: "Commentaire",
  EVALUATED: "Rempli",
  ASSESSED_LATE: "Rempli en retard",
  SELECT_STUDENT_LEVEL: "Sélectionnez le niveau de l'élève",
  STUDENT_PERSONAL_PROFILE: "Contenu proposé",
  ADD_SPECIFIC_CLASS: "Ajouter un contenu spécifique",
  CLASS_NOT_COMPLETED: "Contenu non terminé",
  PAGE: "Page",
  SPECIFY_NEXT_TEACHER: "Spécifiez où le prochain enseignant doit continuer :",
  MORE_CLASSES: "Plus de contenu",
  COMMUNICATE_SOMETHING_COORDINATOR: "Voulez-vous communiquer quelque chose au coordinateur ?",
  ENTER_STATEMENT_HERE: "Entrez la déclaration ici",
  YES_COMMUNICATE: "OUI, je veux communiquer !",
  FINISH: "Terminer",
  NO_FINISH: "Non, termine-le!",
  ACCEPT: "Accepter",
  STUDENT_LEVEL: "Niveau étudiant",
  FILL: "Remplir",
  EXPIRES_AT: "Expire le:",
  PENDENT: "Remplir",
  DELAYED: "Rempli en retard",
  PAGE_COMMENT_REQUIRED: "Page et commentaire requis.",
  TITLE_ALERT_ADD_CONTENT_SPECIFIC: "Contenu Spécifique",
  DESCRIPTION_ALERT_ADD_CONTENT_SPECIFIC:
    "Le contenu spécifique est exclusivement destiné aux cours où le matériel lingofor.me n'a pas été utilisé ou aux cours de niveau M1. Êtes-vous sûr de vouloir continuer avec ce type de contenu ?",

  AFTER_CLASS: "Après le cours",
  FILL_FORM: "Remplir le formulaire",
  FILL_REPORT: "Remplir Rapport",
  PREVIOUS_CLASSES: "Cours précédents",
  LATEST_APPOINTMENTS: "Derniers rendez-vous",
  CODE: "Code",
  STUDENT_DESCRIPTION: "Description de l'élève",
  CLASS_NOT_COMPLETED_CONTINUE: "Cours incomplet. Continuez :",
  WAITING_TEACHER_UPDATE: "En attente de la mise à jour de l'enseignant",
  CLASS_EXPIRED: "Cours expir",
  WAITING_TEACHE_UPDATE: "Waiting for teacher update",

  DETAIL: "Détail",
  OUT_OF_LIMIT: "hors limite",
  FORMS_FILL: "formulaires à remplir",
  FORM_DETAIL: "Détail du Formulaire",
  UPCOMING_MATERIALS: "Contenu à venir",
  FIRST_CLASS_CONTENT:
    "Oups! Votre premier cours est toujours en cours ou n’a pas encore été planifié. Une fois terminé, vous pourrez voir votre progression ici.",

  TITLE_STUDENT_CONTENT: "Quoi de neuf sur Lingofor.me",
  DESCRIPTION_STUDENT_CONTENT:
    "Vous pouvez désormais suivre votre progression avec plus de précision dans le nouveau menu de contenu. Vous aurez votre matériel à venir et l'historique de ce que vous avez vu lors de vos 3 derniers rendez-vous.",

  DEPARTMENT: "Département",
  REPORT_UPDATE: "Mise à jour du rapport",

  LOADING: "Chargement...",
  QUESTIONNAIRES: "Questionnaires",
  NO_QUESTIONS_AVAILABLE: "Aucune question disponible.",
  OPEN_MODAL_QUESTIONNAIRES: "Informations personnelles pour l'immigration",
  MESSAGE_ALERT_QUESTIONNAIRES:
    "Le questionnaire suivant est indispensable pour débuter votre préparation aux entretiens d'immigration, car il contient toutes les informations personnelles nécessaires à nos formateurs pour les corriger et les vérifier. Veuillez répondre à chaque question clairement et en détail.",

  CONNECT_YOUR_GOOGLE_ACCOUNT:
    "Connectez votre compte Google pour synchroniser vos rendez-vous avec votre agenda personnel.",
  GOOGLE_CALENDAR: "Google Agenda",
  SYNC_YOUR_GMAIL_ACCOUNT: "Synchronisez votre compte Gmail.",
  MICROSOFT_OUTLOOK: "Microsoft Outlook",
  SYNC_WITH_YOUR_OUTLOOK_ACCOUNT: "Synchronisez avec votre compte Outlook",
  CONNECT: "Connecter",
  CONNECTED: "Connecté",
  CONNECTING: "Connexion en cours",
  GO_TO_NOTIFICATIONS: "Aller aux notifications",

  SUGESTIONS: "Suggestions",
  TYPE_YOUR_SUGGESTIONS: "Tapez vos suggestions",

  AI_PRACTICE: "Entraînez-vous avec IA",
  AI_PRACTICE_TITLE: "Entraînez-vous avec Lingo AI",
  AI_PRACTICE_DESCRIPTION:
    "Lingo AI générera des exercices personnalisés que vous pourrez pratiquer en dehors des cours.",
  AI_PRACTICE_LIST_DESCRIPTION:
    "La liste ci-dessous présente les derniers thèmes abordés en cours. Vous pouvez en sélectionner jusqu'à {{count}} ; Lingo AI générera alors des exercices adaptés à votre niveau pour vous permettre de vous entraîner.",
  AI_PRACTICE_TOPICS_AVAILABLE: "Sujets disponibles pour la pratique",
  AI_PRACTICE_TEACHER_RECOMMEND: "Ce que vos professeurs vous recommandent de pratiquer...",
  AI_PRACTICE_SELECT_TOPICS: "Sélectionner des sujets",
  AI_PRACTICE_MY_HISTORY: "Mon histoire",
  AI_PRACTICE_GENERATE: "Générer",
  AI_PRACTICE_EMPTY_TITLE:
    "Après votre première leçon dans cette langue, l'option permettant de générer des exercices sera activée afin que vous puissiez commencer à vous entraîner.",

  MY_HISTORY_EXERCISES: "Exercices",
  MY_HISTORY_TOPICS: "Sujets",
  MY_HISTORY_CREATION_DATE: "Date de création",
  MY_HISTORY_LAST_UPDATE: "Dernière mise à jour",
  MY_HISTORY_SCORE: "Score",
  MY_HISTORY_SUGGESTIONS: "Suggestions de Lingo AI",
  MY_HISTORY_REDO: "Répondez aux mêmes exercices que vous avez déjà faits et améliorez votre note.",
  MY_HISTORY_GENERATE_NEW: "Créez des exercices nouveaux et variés sur le même sujet et pratiquez davantage.",
  MY_HISTORY_NO_ITEMS_FOUND:
    "Vous n'avez pas encore généré vos premiers exercices. Cliquez sur le bouton 'Retour', sélectionnez les sujets que vous souhaitez pratiquer, puis cliquez sur le bouton 'Générer'.",
  MY_HISTORY_VIEW_RESULTS: "Cliquez pour voir les résultats",

  IDEAL_FOR_RESUMING_YOUR_STUDIES_WITH_EASE: "Idéal pour reprendre vos études en toute simplicité.",
  MORE_FREQUENCY_TO_ACCELERATE_YOUR_PROGRESS: "Plus de fréquence pour accélérer vos progrès.",
  PREMIUM_PLAN_FOR_MAXIMUM_PROGRESS: "Formule Premium pour une progression optimale.",
};
